import { PortfolioSecurity, Security } from 'generated/types'

export enum PortfolioInvestmentProduct {
  Invest = 'invest',
  Later = 'later',
  Early = 'early',
}

export enum FormattedDisplayedTheme {
  STANDARD = 'Core',
  SUSTAINABLE = 'ESG',
}

export enum PortfolioType {
  ALL = 'All',
  MANAGED = 'Portfolio',
  SELF_DIRECTED = 'SelfDirectedPortfolio',
}

export type NormalizedPortfolioSecurity = PortfolioSecurity & {
  type: PortfolioType
  logoUrl: string
  gainPercentage?: number
  gainValue?: number
  security?: Security
}
